module.exports = __webpack_public_path__ + "img/stage-1-animated.8a8777bd.png";